export default __webpack_public_path__ + "static/media/MATIC-USDT.47450e60.png";